function gregorianToHijri(gDate: Date): { day: number; month: number; year: number } {
  // const gYear = gDate.getFullYear();
  // const gMonth = gDate.getMonth() + 1; // JavaScript months are 0-11
  // const gDay = gDate.getDate();

  const jd = Math.floor((gDate.getTime() - new Date('1944-10-14').getTime()) / 86400000) + 1948440;
  const l = jd - 1948440 + 10632;
  const n = Math.floor((l - 1) / 10631);
  const l1 = l - 10631 * n + 354;
  const j =
    Math.floor((10985 - l1) / 5316) * Math.floor((50 * l1) / 17719) +
    Math.floor(l1 / 5670) * Math.floor((43 * l1) / 15238);
  const l2 =
    l1 -
    Math.floor((30 - j) / 15) * Math.floor((17719 * j) / 50) -
    Math.floor(j / 16) * Math.floor((15238 * j) / 43) +
    29;
  const m = Math.floor((24 * l2) / 709);
  const d = l2 - Math.floor((709 * m) / 24);
  const y = 30 * n + j - 30;

  return { day: d, month: m, year: y };
}

export function isRamadan(): boolean {
  // Get the current date
  const today = new Date();

  // Convert the current date to Hijri (Islamic) date
  const hijriDate = gregorianToHijri(today);

  // Hijri month 9 is Ramadan
  const ramadanMonth = 9;

  // Check if the current Hijri month is Ramadan
  return hijriDate.month === ramadanMonth;
}
